let iosUrl, androidUrl;
iosUrl = "https://itunes.apple.com/us/app/优托邦/id1110311655?l=zh&ls=1&mt=8";
androidUrl = 'http://api.utopa.com.cn/apk/20171214204226053626.apk';
let _czc = _czc || [];
let cnzz_protocol = (("https:" === document.location.protocol) ? " https://" : " http://");
document.write(decodeURI("%3Cspan style='display:none;' id='cnzz_stat_icon_1262267481'%3E%3C/span%3E%3Cscript src='" +
    cnzz_protocol +
    "s22.cnzz.com/z_stat.php%3Fid%3D1262267481' type='text/javascript'%3E%3C/script%3E"));

export function downLoadApp() {
    switch (GetQueryString('channel')) {
        case '0':
            _czc.push(["_trackEvent", "日常", "下载APP", "短信"]); break;
        case '2':
            _czc.push(["_trackEvent", "日常", "下载APP", "小Q公众号"]); break;
        case 'linkage_jnhsyt':
            _czc.push(["_trackEvent", "日常", "下载APP", "家年华收银台日常下载专用"]); break;
        case '3':
            _czc.push(["_trackEvent", "活动", "下载APP", "优托邦购物抽好礼下载专用"]); break;
        case 'parking_lmj':
            _czc.push(["_trackEvent", "停车推广", "下载APP", "奥体-龙门架"]); break;
        case 'parking_bjcs':
            _czc.push(["_trackEvent", "停车推广", "下载APP", "可移背胶-厕所"]); break;
        case 'parking_bjft':
            _czc.push(["_trackEvent", "停车推广", "下载APP", "奥体-可移背胶-扶手梯"]); break;
        case 'parking_gzhgd':
            _czc.push(["_trackEvent", "停车推广", "下载APP", "高德置地公众号发文"]); break;
        case 'parking_gzhutopa':
            _czc.push(["_trackEvent", "停车推广", "下载APP", "广州优托邦奥体店公众号"]); break;
        case 'parking_gzhxq':
            _czc.push(["_trackEvent", "停车推广", "下载APP", "小Q公众号发文"]); break;
        case 'parking_bbs':
            _czc.push(["_trackEvent", "停车推广", "下载APP", "线上论坛发帖"]); break;
        case 'linkage_jzry':
            _czc.push(["_trackEvent", "日常", "下载APP", "家年华周末兼职人员推广专用"]); break;
        case 'linkage_xqls':
            _czc.push(["_trackEvent", "日常", "下载APP", "小Q零售物料协助推广"]); break;
        case 'parking_zt':
            _czc.push(["_trackEvent", "停车推广", "下载APP", "桌贴"]); break;
        case 'parking_ykl':
            _czc.push(["_trackEvent", "停车推广", "下载APP", "亚克力台牌"]); break;
        case 'parking_sp':
            _czc.push(["_trackEvent", "停车推广", "下载APP", "奥体-水牌"]); break;
        case '1':
            _czc.push(["_trackEvent","停车推广","下载APP","优托邦线下活动物料"]);break;
        case 'rc_sh':
            _czc.push(["_trackEvent","日常","下载APP","公众号推文二维码"]);break;
        case 'parking_hkt':
            _czc.push(["_trackEvent","停车推广","下载APP","科学城-货/客体"]);break;
        case 'parking_qs':
            _czc.push(["_trackEvent","停车推广","下载APP","科学城-客体前室"]);break;
        case 'parking_ck':
            _czc.push(["_trackEvent","停车推广","下载APP","科学城-车库"]);break;
        case 'parking_xkj':
            _czc.push(["_trackEvent","停车推广","下载APP","科学城-车库柱身小框架"]);break;
        case 'parking_dq':
            _czc.push(["_trackEvent","停车推广","下载APP","科学城-刀旗"]);break;
        case 'parking_fyc':
            _czc.push(["_trackEvent","停车推广","下载APP","科学城-负一层5,6号电梯外"]);break;
        case 'parking_zj':
            _czc.push(["_trackEvent","停车推广","下载APP","科学城-停车场出口岗亭闸机"]);break;
        case 'parking_gt':
            _czc.push(["_trackEvent","停车推广","下载APP","科学城-停车场出口岗亭"]);break;
        case 'parking_kxczt':
            _czc.push(["_trackEvent","停车推广","下载APP","科学城-桌贴"]);break;
        case 'parking_kxctp':
            _czc.push(["_trackEvent","停车推广","下载APP","科学城-亚克力台牌"]);break;
        case 'parking_kxccs':
            _czc.push(["_trackEvent","停车推广","下载APP","科学城-厕所可移背胶"]);break;
        case 'parking_cy':
            _czc.push(["_trackEvent","停车推广","下载APP","科学城-柱子插页"]);break;
        case 'parking_gzh':
            _czc.push(["_trackEvent","停车推广","下载APP","科学城-微信公众号"]);break;
        case 'parking_dj':
            _czc.push(["_trackEvent","停车推广","下载APP","奥体-当季广告牌"]);break;
        case 'parking_tq':
            _czc.push(["_trackEvent","停车推广","下载APP","奥体-天桥广告牌"]);break;
        case 'parking_ggp':
            _czc.push(["_trackEvent","停车推广","下载APP","奥体-关键出入口大型广告牌/东门广告牌"]);break;
        case 'ledtg_led':
            _czc.push(["_trackEvent","LED推广","下载APP","奥体-LED屏幕"]);break;
        case 'parking_zzpgt':
            _czc.push(["_trackEvent","株洲停车场出入口岗亭"]);break;
        case 'parking_zzxsj':
            _czc.push(["_trackEvent","株洲洗手间"]);break;
        case 'parking_zzdtkj':
            _czc.push(["_trackEvent","株洲电梯框架"]);break;
        case 'parking_zzkftp':
            _czc.push(["_trackEvent","株洲客服台台牌"]);break;
        case 'parking_zzxcd':
            _czc.push(["_trackEvent","兼职人员宣传单"]);break;
        case 'parking_zzwl':
            _czc.push(["_trackEvent","物料投放(x展架，台卡）"]);break;
        case 'parking_zzsp':
        	_czc.push(["_trackEvent","水晶立牌"]);break;
        case 'parking_zzgf':
            _czc.push(["_trackEvent","兼职工服二维码"]);break;
        case 'parking_zzsjtp':
            _czc.push(["_trackEvent","株洲商家台牌"]);break;
        case 'parking_zzsjzt':
            _czc.push(["_trackEvent","株洲商家桌贴"]);break;
        case 'parking_zzpzz':
            _czc.push(["_trackEvent","株洲停车场柱子"]);break;
    }

    setTimeout(function () {
        switch (get_devicesType()) {
            case 'ios':
                window.location.href = iosUrl;
                break;
            case 'android':
            default:
                window.location.href = androidUrl;
        }
    }, 500);
}

/**
 * 判断是否在微信的浏览器
 */
export function is_weixin() {
    let ua = navigator.userAgent.toLowerCase();
    return ua.match(/MicroMessenger/i) === "micromessenger"
}

function GetQueryString(name) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    let r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURI(r[2]); return 'null';
}

/**
 * 返回设备类型
 */
export function get_devicesType() {
    let u = navigator.userAgent;
    let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

    if (isAndroid) {
        return 'android';
    } else if (isiOS) {
        return 'ios';
    } else {
        return 'undefind';
    }
}
